import { NavLink } from 'react-router-dom';
import { Building2, Bed } from 'lucide-react';

/**
 * Route-level tabs shared by the facility pages.
 * Switching tabs navigates between the `/wards` and `/beds` routes, so the
 * active tab is always reflected in the URL (and can be bookmarked/shared).
 * Any `?tab=` status filter is dropped when moving between the two pages.
 */
const FACILITY_TABS = [
  { to: '/wards', label: 'Wards', icon: Building2 },
  { to: '/beds', label: 'Beds', icon: Bed },
];

export function FacilityTabs() {
  return (
    <div className="inline-flex flex-wrap items-center gap-1 rounded-xl border border-border bg-surface p-1">
      {FACILITY_TABS.map(({ to, label, icon: Icon }) => (
        <NavLink
          key={to}
          to={to}
          className={({ isActive }) =>
            `inline-flex items-center gap-2 rounded-lg px-4 py-2 text-sm font-medium transition-colors ${
              isActive
                ? 'bg-primary text-white shadow-sm'
                : 'text-text-muted hover:bg-background hover:text-text'
            }`
          }
        >
          <Icon size={16} />
          {label}
        </NavLink>
      ))}
    </div>
  );
}
